import {sniffPublication} from "./util";
import settings from "./settings";

export const ga = () => {
    const allow = window.Didomi.getUserConsentStatusForVendor('google')
    console.debug(`Google GTAG: ga.js (allowed: ${allow})`);
    if (!allow) return

    var id = 'G-SBSLCX0C5Z'
    if (window.location.host.includes('slovenskenovice.si')) id = 'G-SBSLCX0C5Z'

    var gtmHost = document.location.protocol + `//sgtm.delo.si`
    var gtagConfig = {
        server_container_url: gtmHost,
    }

    // If we are local or stage, fix stuff
    if (window.location.host.includes('stage') || window.location.host.includes('local-')) {
        id = 'G-ELLAFAKE'
        gtmHost = document.location.protocol + `//www.googletagmanager.com`
        delete  gtagConfig.server_container_url
    }

    // TEMP
    // gtmHost = document.location.protocol + `//www.googletagmanager.com`
    // delete  gtagConfig.server_container_url
    // ENDTEMP

    ;(function () {
        var d = document,
            h = d.getElementsByTagName('head')[0],
            s = d.createElement('script');
        s.type = 'text/javascript'
        s.async = true;
        s.src = `${gtmHost}/gtag/js?id=${id}`;
        h.appendChild(s);

        // DATA LAYER && events

        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', id, gtagConfig)
    }());
}
